<template>
  <van-popup v-model="show" round position="bottom">
    <div class="content">
      <h1>选择申请服务类型</h1>
      <div class="list">
        <div class="item" v-for="item in serviceTypes" :key="item.type" :type="item.type" @click="gotoType(item)">
          <img :src="item.icon"/>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      show: false,
      serviceTypes: [
        {
          icon: require("@/assets/apply-s-ico1.png"),
          type: 1,
          supportService: [1] // 贴膜
        },
        {
          icon: require("@/assets/apply-s-ico2.png"),
          type: 2,
          supportService: [2, 3, 4]
        }
      ]
    };
  },
  props: ["value","service","cardId"],
  watch: {
      show(val) {
          this.$emit("input", val);
      },
      value(val){
          this.show = val;
      },
      // service(val) {
      //   console.log(this.cardId, this.service,val);
      // }
  },
  methods: {
    gotoType(item) {
      const cardId = this.cardId;
      let valid = false;
      const service = this.service.toMap(item => ""+item.type);
      item.supportService.forEach(index => {
        let s = service["" + index];
        valid = valid || (s && s.use < s.total);
      });
      const params = {
        id: this.cardId,
        type: this.type,
        service: this.service
      };
      if (!valid) {
        this.goto(`/care/${cardId}/service/none`);
      } else if (item.type === 1) {
        this.$router.push({
          name: "ServiceCode",
          params: params
        });
      } else if (item.type === 2) {
        this.$router.push({
          name: "ServiceForm",
          params: params
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  text-align: center;
  padding: 0 20px 20px 20px;
  h1 {
    margin: 0;
    border: none;
    font-size: 18px;
    font-weight: bold;
  }
  .list{
    .item{
      &:not(:first-child){
        margin-top: 10px;
      }
      img{
        max-width: 100%;
      }
    }
  }
}
</style>
